import {
  createCrossTabBus,
  ADMIN_AUTH_CHANNEL,
  ADMIN_TENANT_CHANNEL,
  ADMIN_CACHE_CHANNEL,
  shouldHonorAdminAuthBusMessage,
  markSameTabExplicitAuth,
  hasSameTabExplicitAuth,
  clearSameTabExplicitAuth,
  type AdminAuthCrossTabMessage,
  type AdminAuthCrossTabScope,
  type AdminTenantCrossTabMessage,
  type AdminCacheCrossTabMessage,
  type ShouldHonorAdminAuthBusMessageContext,
} from 'pi-kiosk-shared/crossTab';

export {
  shouldHonorAdminAuthBusMessage,
  markSameTabExplicitAuth,
  hasSameTabExplicitAuth,
  clearSameTabExplicitAuth,
  type ShouldHonorAdminAuthBusMessageContext,
};

export const adminAuthBus = createCrossTabBus<AdminAuthCrossTabMessage>({
  channelName: ADMIN_AUTH_CHANNEL,
});

export const adminTenantBus = createCrossTabBus<AdminTenantCrossTabMessage>({
  channelName: ADMIN_TENANT_CHANNEL,
});

export const adminCacheBus = createCrossTabBus<AdminCacheCrossTabMessage>({
  channelName: ADMIN_CACHE_CHANNEL,
});

/**
 * XT-G1 — cross-tab only. Initiator already applied local login/logout/refresh effects;
 * notifyLocalSubscribers:false prevents same-tab self-echo.
 * Never put JWTs on the bus payload.
 */
export function publishAdminAuth(message: AdminAuthCrossTabMessage): void {
  adminAuthBus.publish(message, { notifyLocalSubscribers: false });
}

/**
 * G21 honor filter wrapper for admin subscribers.
 * Pass pure session context; never put JWTs on the bus payload.
 */
export function shouldHonorAdminAuth(
  message: AdminAuthCrossTabMessage,
  urlTenantCode: string,
  context: ShouldHonorAdminAuthBusMessageContext
): boolean {
  return shouldHonorAdminAuthBusMessage(message, urlTenantCode, context);
}

export function publishAdminTenantChanged(tenantCode: string): void {
  adminTenantBus.publish({ type: 'tenant-changed', tenantCode });
}

/**
 * G17 / XT-G2 — publish only after successful cookie rotate (not after /me).
 * Platform `/dev` → scope:'platform'; tenant admin → scope:'tenant'.
 */
export function publishAdminSessionRefreshed(
  tenantCode: string,
  scope: AdminAuthCrossTabScope = 'tenant'
): void {
  adminAuthBus.publish(
    { type: 'session-refreshed', tenantCode, scope },
    { notifyLocalSubscribers: false }
  );
}

export function publishAdminCacheInvalidate(scope: string): void {
  adminCacheBus.publish({ type: 'cache-invalidate', scope });
}
